const prefix = 'devices';

export const FETCH_FILTERED = `${prefix}/FETCH_FILTERED`;
export const FIND = `${prefix}/FIND`;
